"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Input = void 0;
var components_1 = require("../../components");
var input_styles_css_1 = __importDefault(require("./input.styles.css"));
var Input = /** @class */ (function () {
    function Input() {
        var optionalProps = components_1.options.getProps();
        var theme = optionalProps.theme && optionalProps.theme.input ? optionalProps.theme.input : input_styles_css_1.default.input;
        this.ref = null;
        this.props = {
            placeholder: optionalProps.placeholder,
            theme: theme,
        };
        this.render();
    }
    Input.prototype.createMarkup = function () {
        var el = document.createElement('input');
        var placeholder = this.props.placeholder || 'add more people...';
        el.classList.add(this.props.theme);
        el.setAttribute('type', 'email');
        el.setAttribute('placeholder', placeholder);
        return el;
    };
    Input.prototype.render = function () {
        var markup = this.createMarkup();
        this.ref = markup;
    };
    return Input;
}());
exports.Input = Input;
